// Lazy loader for bwip-js (public/bwip-js.min.js, global `bwipjs`).
// Loaded only when a label contains or adds a barcode.
let promise = null;
const listeners = new Set();

export const bwipReady = () => typeof window !== 'undefined' && !!window.bwipjs && typeof window.bwipjs.toSVG === 'function';

/** Called once when bwip-js finishes loading (used to re-render the canvas). */
export function onBwipReady(fn) {
  listeners.add(fn);
}

export function ensureBwip() {
  if (bwipReady()) return Promise.resolve(window.bwipjs);
  if (promise) return promise;
  promise = new Promise((resolve, reject) => {
    const el = document.createElement('script');
    el.src = new URL('bwip-js.min.js', document.baseURI).href;
    el.async = true;
    el.onload = () => {
      if (!bwipReady()) {
        reject(new Error('bwip-js loaded but no bwipjs.toSVG'));
        return;
      }
      resolve(window.bwipjs);
      for (const fn of listeners) fn();
    };
    el.onerror = () => {
      promise = null;
      reject(new Error('Could not load the barcode renderer (bwip-js.min.js)'));
    };
    document.head.appendChild(el);
  });
  return promise;
}
